import React, { Component } from "react";
import { Row, Col, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import CartContext from "./CartContext";
import { DemoButton } from "./CommonModules";

/* -------------------------
   HRM Feature Placeholder Modules
   ------------------------- */
const DepartmentsModule = () => (
  <Card.Body>
    <h6>Departments</h6>
    <p className="small text-muted">
      Create and manage organizational units, roles, and reporting structures.
    </p>
  </Card.Body>
);

const EmployeeDbModule = () => (
  <Card.Body>
    <h6>Employee Database</h6>
    <p className="small text-muted">
      Centralized employee records with KYC, documents, contracts, and payroll
      info.
    </p>
  </Card.Body>
);

const TimesheetModule = () => (
  <Card.Body>
    <h6>Timesheets</h6>
    <p className="small text-muted">
      Track employee hours, shifts, approvals, and integrate with payroll.
    </p>
  </Card.Body>
);

const LeaveModule = () => (
  <Card.Body>
    <h6>Leave Management</h6>
    <p className="small text-muted">
      Automate leave requests, holiday calendars, and approval workflows.
    </p>
  </Card.Body>
);

const EmployeeActionsModule = () => (
  <Card.Body>
    <h6>Employee Actions</h6>
    <p className="small text-muted">
      Handle promotions, transfers, increments, disciplinary actions, and more.
    </p>
  </Card.Body>
);

const EmployeeRequestsModule = () => (
  <Card.Body>
    <h6>Employee Requests</h6>
    <p className="small text-muted">
      Self-service portal for employees to submit claims, requests, or
      documents.
    </p>
  </Card.Body>
);

const PerformanceModule = () => (
  <Card.Body>
    <h6>Performance Management</h6>
    <p className="small text-muted">
      Define KPIs, run appraisals, 360° feedback, and track performance scores.
    </p>
  </Card.Body>
);

const OnboardingModule = () => (
  <Card.Body>
    <h6>Onboarding</h6>
    <p className="small text-muted">
      Digitize new hire onboarding with offer letters, checklists, and
      orientation tasks.
    </p>
  </Card.Body>
);

const ExitModule = () => (
  <Card.Body>
    <h6>Exit/Resign</h6>
    <p className="small text-muted">
      Automate resignation requests, clearances, exit interviews, and final
      settlements.
    </p>
  </Card.Body>
);

const HolidaysModule = () => (
  <Card.Body>
    <h6>Holiday Calendar</h6>
    <p className="small text-muted">
      Define national & company holidays with region-wise customization.
    </p>
  </Card.Body>
);

const ReportsModule = () => (
  <Card.Body>
    <h6>HR Reports</h6>
    <p className="small text-muted">
      Real-time analytics on headcount, attrition, payroll costs, and
      compliance.
    </p>
  </Card.Body>
);

const AccountingModule = () => (
  <Card.Body>
    <h6>Payroll & Accounting</h6>
    <p className="small text-muted">
      Payroll runs, payslips, tax deductions, and integration with finance.
    </p>
  </Card.Body>
);

/* -------------------------
   HRM Main Class Component
   ------------------------- */
export class Hrm extends Component {
  static contextType = CartContext;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleTryNow = () => {
    const ctx = this.context || {};
    const {
      userData,
      ShowUserLoginNew,
      prods,
      SetSelectedProduct,
      ProductType,
    } = ctx;

    if (!userData || userData.loginStatus !== "active") {
      if (typeof ShowUserLoginNew === "function") ShowUserLoginNew(true);
      return;
    }

    const hrType = ProductType?.HRM || ProductType?.EmployeeMgmt;
    if (hrType && Array.isArray(prods)) {
      const selected = prods.find((p) => p.productType === hrType);
      if (selected && typeof SetSelectedProduct === "function") {
        SetSelectedProduct(selected);
        return;
      }
    }

    if (typeof ctx.HandleTryNowButtonClick === "function") {
      ctx.HandleTryNowButtonClick(hrType);
    }
  };

  render() {
    const ctx = this.context || {};
    if (!ctx?.EcSettings || ctx.EcSettings.length === 0) return <></>;

    const base = ctx.GetEcSettingValueByName?.("StorageBlobImageUrl") || "";

    const moduleList = [
      DepartmentsModule,
      EmployeeDbModule,
      TimesheetModule,
      LeaveModule,
      EmployeeActionsModule,
      EmployeeRequestsModule,
      PerformanceModule,
      OnboardingModule,
      ExitModule,
      HolidaysModule,
      ReportsModule,
      AccountingModule,
    ];

    return (
      <>
        {/* Hero Section */}
        <section className="hero container-fluid py-5 bg-white">
          <div className="container">
            <div className="row align-items-center gy-4">
              <div className="col-lg-7">
                <span className="badge-sub">HRM • People Management</span>
                <h1 className="display-5 fw-bold mt-3">
                  Manage your workforce with ease
                </h1>
                <p className="lead text-muted mb-4">
                  ElasticCART HRM helps you simplify HR operations — from
                  recruitment & onboarding to payroll, performance reviews, and
                  employee exits.
                </p>
                <div className="mt-4">
                  {/* <Button
                    variant="light"
                    size="lg"
                    className="me-2"
                    onClick={this.handleTryNow}
                  >
                    <i className="fa-solid fa-play me-2" /> Book a demo
                    +91-98805 82728
                  </Button> */}
                  <Button
                    variant="outline-primary"
                    size="lg"
                    as={Link}
                    to="/Checkout"
                    onClick={this.handleTryNow}
                  >
                    <i className="fa-solid fa-flask me-2" /> Start free trial
                  </Button>
                </div>
              </div>

              <div className="col-lg-5">
                <div className="card card-feature p-4">
                  <div className="card-body">
                    <h5 className="card-title mb-3">Key HRM Benefits</h5>
                    <ul className="list-unstyled small text-muted">
                      <li>✔ Centralized Employee Database</li>
                      <li>✔ Automated Leave & Attendance Tracking</li>
                      <li>✔ Performance & Appraisal Workflows</li>
                      <li>✔ Easy Onboarding & Exit Processes</li>
                      <li>✔ Payroll & Compliance Integration</li>
                    </ul>
                  </div>
                </div>
                <DemoButton></DemoButton>
              </div>

              {/* Demo Video */}
              {/* <div className="col-lg-12 my-5">
                <video controls height="400px" autoPlay muted loop width="100%">
                  <source src={base + "HrmVideo.mp4"} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div> */}
            </div>
          </div>
        </section>

        {/* HRM Modules Section */}
        <section className="container my-5">
          <h5 className="display-6 text-dark mb-4 border-start border-5 border-primary ps-3">
            Explore HRM Modules
          </h5>
          <Row className="g-3">
            {moduleList.map((Module, idx) => (
              <Col md={6} lg={4} key={idx}>
                <Card className="bg-light shadow-sm h-100 hover-shadow">
                  <Module />
                </Card>
              </Col>
            ))}
          </Row>
        </section>
      </>
    );
  }
}

export default Hrm;
